import type { SVGProps } from 'react'

interface LandscapeIconProps extends SVGProps<SVGSVGElement> {}

export function LandscapeIcon(props: LandscapeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M150.39-260q-22.7 0-32.54-19.89-9.85-19.88 3.61-37.96L253-493.54q5.62-7.23 13.15-10.84 7.54-3.62 15.77-3.62t15.77 3.62q7.54 3.61 13.16 10.84L441.15-320h320.77l-200-266-86.08 114.23q-9.3 12.16-21.07 12.46-11.77.31-21.08-6.38-9.31-6.69-12.34-18.54-3.04-11.84 6.27-24L533-648.15q5.62-7.23 13.15-10.85 7.54-3.61 15.77-3.61t15.77 3.61q7.54 3.62 13.16 10.85l247.69 330.3q13.46 18.08 3.61 37.96Q832.31-260 809.61-260H150.39zm301.53-60h310-330.08 68.89-48.81zm-253.84 0h168.07l-84.23-112.77L198.08-320zm0 0h168.07-168.07z" />
    </svg>
  )
}
